/*
 * ModalConstants
 */

export const OPEN_MODAL = 'ideal/components/Modal/Right/OPEN_MODAL';
export const CLOSE_MODAL = 'ideal/components/Modal/Right/CLOSE_MODAL';
